import EnumClass, { build } from '../EnumClass';
import data, { InflectionTypeId, InflectionTypeData } from './data';
import * as Translations from './translations';

export class InflectionType extends EnumClass<InflectionTypeId, InflectionTypeData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: INFLECTION_TYPES,
  getById: getInflectionTypeById,
  marshaller: InflectionTypeMarshaller,
} = build<InflectionTypeId, InflectionTypeData, InflectionType>('InflectionTypeEnum', data, InflectionType);
